import { render, staticRenderFns } from "./LayoutViews.vue?vue&type=template&id=77afc028&scoped=true"
import script from "./LayoutViews.vue?vue&type=script&lang=js"
export * from "./LayoutViews.vue?vue&type=script&lang=js"
import style0 from "./LayoutViews.vue?vue&type=style&index=0&id=77afc028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afc028",
  null
  
)

export default component.exports